module.exports = __webpack_public_path__ + "img/promotions-may.b3de3a0c.png";